import dayjs from 'dayjs'
import { AxiosResponse } from 'axios'
import dayOfYear from 'dayjs/plugin/dayOfYear'

import { api } from '@api'
import {
  DeclineTicket,
  Filters,
  Observation,
  DeliveryNote,
  Ticket,
  GetTicketsResponse,
  CommonTicketForm,
  GetTicketByIdResponse,
} from '@types'

dayjs.extend(dayOfYear)

type Params = {
  filters?: Filters
}

type PayloadDecline = { id: number; payload: DeclineTicket }

type PayloadDeliveryNote = { id: number; payload: DeliveryNote }

type PayloadChange = { id: number; payload: CommonTicketForm }

type AcceptTicketPayload = {
  id: number
  note: Observation
  driverId?: number
  truckId?: number
  trailerId?: number
}

const getTickets = async (params: Params) => {
  const { filters } = params
  const response = await api.get<GetTicketsResponse>('/tickets', {
    params: {
      ...filters,
    },
  })

  const ticketsAux = response.data.tickets?.tickets.map((ticket: Ticket) => {
    const withdrawalDay = dayjs(ticket.withdrawalDate).format('DD-MM-YYYY')
    const withdrawalTime = dayjs(ticket.withdrawalDate).format('HH:mm')
    const withdrawalDayOfYear = dayjs(ticket.withdrawalDate).dayOfYear() // revisar compatibilidad con api al cambiar de año
    return {
      ...ticket,
      withdrawalDay,
      withdrawalTime,
      withdrawalDayOfYear,
    }
  }) as Ticket[]
  const tickets = ticketsAux
    ? {
        tickets: ticketsAux,
        total: response.data.tickets?.total,
      }
    : response.data.tickets
  return tickets
}

const getTicketById = async (id?: number | undefined) => {
  const response = await api.get<GetTicketByIdResponse>(`/tickets/${id}`)

  const { ticket, mondayOfWeek } = response.data
  ticket?.notes?.sort((a, b) => dayjs(b.createAt).unix() - dayjs(a.createAt).unix())
  return { ticket, mondayOfWeek }
}

const acceptTicket = async ({ id, note, driverId, truckId, trailerId }: AcceptTicketPayload) => {
  const payload = { note, driverId, truckId, trailerId }
  const response = await api.put<GetTicketsResponse>(`/tickets/${id}/confirm`, {
    payload,
  })

  return response.data.tickets
}

const declineTicket = async ({ id, payload }: PayloadDecline) => {
  const response = await api.put<GetTicketsResponse>(`/tickets/${id}/decline`, {
    ticket: { ...payload },
  })

  return response.data.tickets
}

const deliveryNoteTicket = async ({ id, payload }: PayloadDeliveryNote) => {
  const response = await api.put<GetTicketsResponse>(`/tickets/${id}/delivery_note`, {
    deliveryNote: { ...payload },
  })
  return response.data.tickets
}

const changeTicket = async ({ id, payload }: PayloadChange) => {
  const response = await api.put<AxiosResponse>(`/tickets/${id}`, {
    ticket: { ...payload },
  })

  return response.data
}

const manualAssign = async ({
  id,
  carrierId,
  reason,
}: {
  id: number
  carrierId: number
  reason: string
}) => {
  const response = await api.put<GetTicketsResponse>(`/tickets/${id}/manual`, {
    ticket: { carrierId, reason },
  })

  return response.data.tickets
}

export const TicketsApi = {
  getTickets,
  getTicketById,
  acceptTicket,
  declineTicket,
  deliveryNoteTicket,
  changeTicket,
  manualAssign,
}
